module.exports = flarum.core.compat['components/PostsUserPage'];